export default __webpack_public_path__ + "static/media/not-ok2.87318622.png";